import React, { useState } from "react";
import { connect } from "react-redux";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withToast } from "../contexts/toastr.context";
import { Chart, Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import leftIcon from "../_assets/images/left_icon.png";
import Select from "react-select";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

let labels = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const ENGAGEMENT_ANALYTICS_ROUTE = "/engagement-analytics";

const pieOptions = {
  maintainAspectRatio: false,
  scales: {
    x: {
      display: false,
      grid: {
        display: false,
      },
    },
    y: {
      display: false,
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      position: "right",
      display: true,
      labels: {
        padding: 10,
        font: {
          size: 14,
        },
      },
    },
    datalabels: {
      display: true,
      color: function (ctx) {
        return ctx;
      },
      anchor: "end",
      align: "end",
      font: {
        weight: "bold",
        size: 12,
      },
      formatter: function (value, context) {
        return value + "%";
      },
    },
    outlabels: {
      stretch: 25,
      text: "%l - %p",
      font: {
        resizable: true,
        minSize: 12,
        maxSize: 13,
      },
    },
  },
  layout: {
    padding: {
      top: 15,
      right: 15,
      bottom: 45,
      left: 15,
    },
  },
};

const EngagementAnalytics = ({ addToast, organization, history, user }) => {
  const [filterOptions, setFilterOptions] = useState([
    { label: "By Profession", value: "profession" },
    { label: "By Department", value: "department" },
  ]);

  const professionFilter = [
    { label: "Physician", value: "physician" },
    { label: "Nurse", value: "nurse" },
    { label: "Allied Health", value: "alliedHealth" },
    { label: "Auxiliary", value: "auxiliary" },
  ];

  const departmentFilter = [
    { label: "Critical Care", value: "criticalCare" },
    { label: "Emergency", value: "emergency" },
    { label: "Internal Medicine", value: "internalMedicine" },
    { label: "Surgery", value: "surgery" },
  ];

  // rolloutParticipation
  const [rolloutParticipationProfession, setRolloutParticipationProfession] =
    useState({});
  const [rolloutParticipationDepartment, setRolloutParticipationDepartment] =
    useState({});

  // weeklyActiveUsers
  const [weeklyActiveUsersProfession, setWeeklyActiveUsersProfession] =
    useState({});
  const [weeklyActiveUsersDepartment, setWeeklyActiveUsersDepartment] =
    useState({});

  // meditationTopics
  const [meditationTopicsProfession, setMeditationTopicsProfession] = useState(
    {}
  );
  const [meditationTopicsDepartment, setMeditationTopicsDepartment] = useState(
    {}
  );

  // coachingTopics
  const [coachingTopicsProfession, setCoachingTopicsProfession] = useState({});
  const [coachingTopicsDepartment, setCoachingTopicsDepartment] = useState({});

  const [selectedProfession, setSelectedProfession] = useState(null);
  // const [detailedFilterOptions, setDetailedFilterOptions] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  return (
    <div className="page-container ml-auto dashboard-container engagement-container">
      <div className="flex pb-4 back-btn-container items-center cursor-pointer">
        <img src={leftIcon} alt="" onClick={() => history.push("/")} />
        <span
          className="ml-3 text-xl home-text t-grey"
          onClick={() => history.push("/")}>
          Home
        </span>
      </div>
      <div className="flex w-9/12">
        <div className="w-full">
          <div className="card rounded-md bg-white p-8">
            <div className="flex items-center">
              <span className="font-bold text-xl text-primary">
                Engagement Overview
              </span>
            </div>
            <div className="flex mt-5 dashboard-count-container">
              <div className="pr-6">
                <p className="text-base text-primary font-bold">
                  Participants Signed-Up
                </p>
                <p className="text-base t-grey font-bold">260/400 signed-up</p>
              </div>
              <div className="pl-6 pr-6 border-left">
                <p className="text-base text-primary font-bold">
                  Users this Month
                </p>
                <p className="text-base t-grey font-bold">198 users</p>
              </div>
              <div className="pl-6 pr-6 border-left">
                <p className="text-base text-primary font-bold">
                  Meditations this Month
                </p>
                <p className="text-base t-grey font-bold">233 Meditations</p>
              </div>
              <div className="pl-6 border-left pr-6">
                <p className="text-base text-primary font-bold">
                  Latest Survey
                </p>
                <p className="text-base t-grey font-bold">85/150 responded </p>
              </div>
              <div className="pl-6 border-left">
                <p className="text-base text-primary font-bold">
                  Coaching this Month
                </p>
                <p className="text-base t-grey font-bold">130 sessions</p>
              </div>
            </div>
          </div>
          <div
            className="card rounded-md bg-white p-8 mt-4"
            style={{ minHeight: "45vh" }}>
            <div className="mb-6 flex justify-between">
              <span className="font-bold text-xl t-grey">
                Rollout Participation Tracking
              </span>
              <div className="flex w-2/3">
                <div className="flex justify-around w-1/2 items-center">
                  <label className="t-grey">By Profession</label>
                  <Select
                    options={professionFilter}
                    className="filter-dropdown w-1/2"
                    placeholder="Filter"
                    value={rolloutParticipationProfession}
                    onChange={async (data) => {
                      setRolloutParticipationProfession(data);
                    }}
                  />
                </div>
                <div className="flex justify-around w-1/2 items-center">
                  <label className="t-grey">Select Department</label>
                  <Select
                    options={departmentFilter}
                    className="filter-dropdown w-1/2"
                    value={rolloutParticipationDepartment}
                    onChange={async (data) => {
                      setRolloutParticipationDepartment(data);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="flex">
              <div style={{ width: "80%" }}>
                <Line
                  data={{
                    labels: labels,
                    datasets: [
                      {
                        label: "Dataset 1",
                        data: [10, 15, 25, 30, 35, 40, 40],
                        borderColor: "#576CD0",
                        backgroundColor: "#576CD0",
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                  }}
                />
              </div>
              <div className="text-left" style={{ width: "20%" }}>
                <div
                  className="border p-2 rounded-md"
                  style={{ background: "#F1F3FD" }}>
                  <div className="">
                    <span className="text-xs" style={{ color: "#434449" }}>
                      Campaign Details
                    </span>
                  </div>
                  <div>
                    <div>
                      <span className="text-xs" style={{ color: "#434449" }}>
                        Total Invites: 400
                      </span>
                    </div>
                    <div>
                      <span className="text-xs" style={{ color: "#434449" }}>
                        Goal: 75%
                      </span>
                    </div>
                    <div>
                      <span className="text-xs" style={{ color: "#434449" }}>
                        Current: 65%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="card rounded-md bg-white p-8 mt-4"
            style={{ minHeight: "45vh" }}>
            <div className="mb-6 flex justify-between">
              <span className="font-bold text-xl t-grey">
                Weekly Active Users
              </span>
              <div className="flex w-2/3">
                <div className="flex justify-around w-1/2 items-center">
                  <label className="t-grey">By Profession</label>
                  <Select
                    options={professionFilter}
                    className="filter-dropdown w-1/2"
                    placeholder="Filter"
                    value={weeklyActiveUsersProfession}
                    onChange={async (data) => {
                      setWeeklyActiveUsersProfession(data);
                    }}
                  />
                </div>
                <div className="flex justify-around w-1/2 items-center">
                  <label className="t-grey">Select Department</label>
                  <Select
                    options={departmentFilter}
                    className="filter-dropdown w-1/2"
                    value={weeklyActiveUsersDepartment}
                    onChange={async (data) => {
                      setWeeklyActiveUsersDepartment(data);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="flex">
              <div style={{ width: "80%" }}>
                <Line
                  data={{
                    labels: labels,
                    datasets: [
                      {
                        label: "Dataset 1",
                        data: [10, 20, 30, 25, 30, 40, 25],
                        borderColor: "#576CD0",
                        backgroundColor: "#576CD0",
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                  }}
                />
              </div>
              <div className="text-left" style={{ width: "20%" }}>
                <div
                  className="border p-2 rounded-md"
                  style={{ background: "#F1F3FD" }}>
                  <div>
                    <div>
                      <span className="text-xs" style={{ color: "#434449" }}>
                        This Week: 100
                      </span>
                    </div>
                    <div>
                      <span className="text-xs" style={{ color: "#434449" }}>
                        Last Week: 68
                      </span>
                    </div>
                    <div>
                      <span className="text-xs" style={{ color: "#434449" }}>
                        Survey Completion: 60%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="card rounded-md bg-white p-8 mt-4"
            style={{ minHeight: "40vh" }}>
            <div className="mb-6 flex justify-between">
              <span className="font-bold text-xl t-grey">
                Meditation Topics of Interest
              </span>
              <div className="flex w-2/3">
                <div className="flex justify-around w-1/2 items-center">
                  <label className="t-grey">By Profession</label>
                  <Select
                    options={professionFilter}
                    className="filter-dropdown w-1/2"
                    placeholder="Filter"
                    value={meditationTopicsProfession}
                    onChange={async (data) => {
                      setMeditationTopicsProfession(data);
                    }}
                  />
                </div>
                <div className="flex justify-around w-1/2 items-center">
                  <label className="t-grey">Select Department</label>
                  <Select
                    options={departmentFilter}
                    className="filter-dropdown w-1/2"
                    value={meditationTopicsDepartment}
                    onChange={async (data) => {
                      setMeditationTopicsDepartment(data);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="flex">
              <div>
                <Chart
                  type="pie"
                  style={{
                    minHeight: "400px",
                    maxHeight: "400px",
                  }}
                  plugins={[
                    ChartDataLabels,
                    {
                      beforeInit: function (chart) {
                        const originalFit = chart.legend.fit;
                        chart.legend.fit = function fit() {
                          originalFit.bind(chart.legend)();
                          this.height += 15;
                        };
                      },
                    },
                  ]}
                  data={{
                    labels: [
                      "Coping with Grief/Loss",
                      "Work-Life Balance",
                      "Stress/Anxiety Management",
                      "Purpose and Professional Satisfaction",
                    ],
                    datasets: [
                      {
                        data: [65, 15, 10, 10],
                        backgroundColor: [
                          "#9BC4F8",
                          "#9FDFAD",
                          "#F9ADAD",
                          "#FFE1A8",
                        ],
                      },
                    ],
                    text: "23%",
                  }}
                  options={pieOptions}
                />
              </div>
            </div>
          </div>
          <div
            className="card rounded-md bg-white p-8 mt-4"
            style={{ minHeight: "30vh" }}>
            <div className="mb-6 flex justify-between">
              <span className="font-bold text-xl t-grey">
                Coaching Topics of Interest
              </span>
              <div className="flex w-2/3">
                <div className="flex justify-around w-1/2 items-center">
                  <label className="t-grey">By Profession</label>
                  <Select
                    options={professionFilter}
                    className="filter-dropdown w-1/2"
                    placeholder="Filter"
                    value={coachingTopicsProfession}
                    onChange={async (data) => {
                      setCoachingTopicsProfession(data);
                    }}
                  />
                </div>
                <div className="flex justify-around w-1/2 items-center">
                  <label className="t-grey">Select Department</label>
                  <Select
                    options={departmentFilter}
                    className="filter-dropdown w-1/2"
                    value={weeklyActiveUsersDepartment}
                    onChange={async (data) => {
                      setCoachingTopicsDepartment(data);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="flex">
              <div>
                <Chart
                  type="pie"
                  style={{
                    minHeight: "400px",
                    maxHeight: "400px",
                  }}
                  plugins={[
                    ChartDataLabels,
                    {
                      beforeInit: function (chart) {
                        const originalFit = chart.legend.fit;
                        chart.legend.fit = function fit() {
                          originalFit.bind(chart.legend)();
                          this.height += 15;
                        };
                      },
                    },
                  ]}
                  data={{
                    labels: [
                      "Coping with Grief/Loss",
                      "Work-Life Balance",
                      "Stress/Anxiety Management",
                      "Purpose and Professional Satisfaction",
                    ],
                    datasets: [
                      {
                        data: [65, 15, 10, 10],
                        backgroundColor: [
                          "#9BC4F8",
                          "#9FDFAD",
                          "#F9ADAD",
                          "#FFE1A8",
                        ],
                      },
                    ],
                    text: "23%",
                  }}
                  options={pieOptions}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth,
  organization: state.orgData,
});

const EngagementAnalyticsPage = withToast(
  connect(mapStateToProps)(EngagementAnalytics)
);

export default EngagementAnalyticsPage;
